import React from "react";

const DataField = (field, value) => (
  <div className="data-field">
    <div className="field">{field}</div>
    <div className="value">{value}</div>
  </div>
);

export default DataField;
